import React from 'react'
import PropTypes from 'prop-types'
import i18n from 'core/common/i18n'
import StatusBullet from 'core/components/StatusBullet'

const STATUS_SEVERITY = {
  BLOCKED: 'error',
  INACTIVE: 'default',
  DRAFT: 'draft',
  NEW: 'info',
  PUBLISHED: 'success',
  UNPUBLISHED: 'warning',
}

function EnhancedProductStatus({ status }) {
  return (
    <StatusBullet
      size="small"
      color={STATUS_SEVERITY[status]}
      label={i18n.t(`productStatus.bullet.${status}`)}
    />
  )
}

EnhancedProductStatus.propTypes = {
  status: PropTypes.string.isRequired,
}

export default EnhancedProductStatus
